import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";

Vue.use(Router);
// 处理重复点击相同路由报错
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/download",
      name: "download",
      component: require("@/pages/download/download.vue").default
    },
    {
      redirect: "/home",
      path: "/",
      name: "main",
      component: require("@/pages/main/index").default,
      children: [
        {
          path: "home",
          name: "home",
          component: require("@/pages/main/home/index").default
        },
        {
          path: "certificate",
          name: "certificate",
          component: require("@/pages/main/certificate/index").default
        },
        {
          path: "meal",
          name: "meal",
          component: require("@/pages/main/meal/index").default
        },
        {
          path: "search",
          name: "search",
          component: require("@/pages/main/search/index").default
        },
        {
          path: "detail",
          name: "detail",
          component: require("@/pages/main/detail/index").default
        },
        {
          path: "activities",
          name: "activities",
          component: require("@/pages/main/activities/index").default
        },
        // {
        //   path: 'activitiesDetail',
        //   name: 'activitiesDetail',
        //   component: require('@/pages/main/activities/components/activities-detail').default,
        // },
        {
          path: "bargain",
          name: "bargain",
          component: require("@/pages/main/bargain/index").default
        },
        {
          path: "getcoupon",
          name: "getcoupon",
          component: require("@/pages/main/get-coupon/index").default
        },
        {
          path: "helpcenter",
          name: "helpcenter",
          component: require("@/pages/main/helpcenter/index").default
        },
        {
          path: "shoppinglist",
          name: "shoppinglist",
          component: require("@/pages/main/shoppinglist/index").default
        },
        {
          path: "replenishList",
          name: "replenishList",
          component: require("@/pages/main/replenishList/index").default
        },
        {
          path: "smActivityList",
          name: "smActivityList",
          component: require("@/pages/main/smActivityList/index").default
        },
        {
          path: "subjectDetail",
          name: "subjectDetail",
          component: require("@/pages/main/subjectDetail/index").default
        },
        {
          path: "control",
          name: "control",
          component: require("@/pages/main/control/index").default
        },
        {
          path: "shoppingsquare",
          name: "shoppingsquare",
          component: require("@/pages/main/shoppingsquare/index").default
        }
      ]
    },

    {
      path: "/login",
      name: "login",
      component: require("@/pages/login/index").default
    },
    {
      path: "/person",
      name: "person",
      component: require("@/pages/person/index").default,
      children: [
        {
          path: "center",
          name: "center",
          component: require("@/pages/person/components/person-center/index")
            .default
        },
        /* {
          path: "myorder",
          name: "myorder",
          component: require("@/pages/person/components/person-order/index")
            .default
        },
        {
          path: "orderdetail",
          name: "orderdetail",
          component: require("@/pages/person/components/person-order/order-detail")
            .default
        }, */
        /* {
          path: "service",
          name: "service",
          component: require("@/pages/person/components/person-service/index")
            .default,
          redirect: "service/servicecenter",
          children: [
            {
              path: "servicecenter",
              name: "servicecenter",
              component: require("@/pages/person/components/person-service/service-center.vue")
                .default
            },
            {
              path: "aftersale",
              name: "aftersale",
              component: require("@/pages/person/components/person-service/apply-sale.vue")
                .default
            }
          ]
        },
        {
          path: "servicedetail",
          name: "servicedetail",
          component: require("@/pages/person/components/person-service/service-detail")
            .default
        },
        {
          path: "coupon",
          name: "coupon",
          component: require("@/pages/person/components/person-coupon").default
        }, */
        {
          path: "collect",
          name: "collect",
          component: require("@/pages/person/components/person-collect/index")
            .default
        },
        {
          path: "check",
          name: "check",
          component: require("@/pages/person/components/person-check/index")
            .default
        }
      ]
    },
    {
      path: "/cart",
      name: "cart",
      component: require("@/pages/cart/index").default,
      children: [
        {
          path: "cartlist",
          name: "cartlist",
          component: require("@/pages/cart/components/cart-goodsList").default
        },
        {
          path: "verify",
          name: "verify",
          component: require("@/pages/cart/components/cart-verify").default
        },
        {
          path: "pay",
          name: "pay",
          component: require("@/pages/cart/components/cart-pay").default
        }
      ]
    },
    {
      path: "*",
      redirect: "/home"
    }
  ]
});
router.beforeEach(function(to, from, next) {
  console.log(to.name);
  var fullPath = to.path.split("/");

  if (fullPath.indexOf("cart") > -1) {
    if (!localStorage.getItem("token")) {
      return next("/login");
    }
  }
  // if (fullPath.indexOf("pay") != -1 ) {
  //   // let routeData = router.resolve({
  //   //   path: "/cart/pay",
  //   // });
  //   // window.open('/cart/pay', '_blank');
  //   return
  // }
  next();
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js